'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _StandardResponses = require('../constants/StandardResponses');

var _Units = require('../constants/Units');

exports.default = (0, _immutable.Record)({
  enabled: false,
  usingCustomResponse: false,
  standardResponse: _StandardResponses.FEW_MINUTES,
  customResponseQuantity: 5,
  customResponseUnit: _Units.MINUTES
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/typical-response-time/records/TypicalResponseTime.js
// module id = 98
// module chunks = 2 3